import React from 'react'
import { Modal } from 'react-bootstrap'
import styles from './eventRatingModal.module.scss'
import { useTranslation } from 'react-i18next'
import Icon from '../../../components/icon'
const StarsRating = ({ statNum }) => {
  if (!statNum) return null

  const stArr = []
  const statNumRounded = Math.round(statNum * 2) / 2

  for (let i = 0; i < 5; i += 1) {
    if (statNumRounded >= i + 1) {
      stArr.push(<Icon name="star" className="starIcon" key={i} />)
    } else if (statNumRounded >= i + 0.5) {
      stArr.push(<Icon name="star-half-stroke" className="starIcon" key={i} />)
    } else {
      stArr.push(<Icon name="star-regular" className="starIcon" key={i} />)
    }
  }

  return <>{stArr}</>
}

export default function EventRatingModal({ show, handleClose, event }) {
  const statNum = event?.event_rating_average
  const reviewCount =
    event?.volunteer.filter(participant => participant.event_rating).length ?? 0

  const eventRatings =
    event?.volunteer.length > 0 ? event.volunteer : event.participants

  const { t } = useTranslation()

  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className={styles.mainContainer}>
          <h4>{event.title}</h4>
          <h2 className={styles.mainRatingAverage}>{statNum?.toFixed(1)}</h2>
          <span className={styles.stars}>
            <StarsRating key="mainAverage" statNum={statNum} />
          </span>
          {reviewCount && (
            <p className="mt-2">
              {t('users.civic_participation.review_count', {
                count: reviewCount,
              })}
            </p>
          )}
          {eventRatings?.map(participant => {
            if (participant?.event_rating === null) return

            return (
              <div
                key={event.title + participant.user?.name}
                className={styles.ratingDetails}
              >
                <div className={styles.ratingMainContent}>
                  <div>{participant.user?.name}</div>
                  <span className={styles.stars}>
                    <StarsRating
                      key={event.title + participant.user?.name + 'rating'}
                      statNum={participant?.event_rating}
                    />
                  </span>
                </div>
                <div className={styles.ratingComment}>
                  {participant.event_comment}
                </div>
              </div>
            )
          })}
        </div>
      </Modal.Body>
    </Modal>
  )
}
